import React from 'react';
import { useTranslation } from 'react-i18next';

const BlogHeader: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="bg-[#0A1628] py-24 relative overflow-hidden">
      <div
        className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage:
            'linear-gradient(rgba(255, 255, 255, 0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.1) 1px, transparent 1px)',
          backgroundSize: '60px 60px'
        }}
      />
      <div className="relative max-w-6xl mx-auto px-6 text-center">
        <p className="text-teal-400 text-xs font-bold uppercase tracking-[0.2em] mb-4">{t('blog.label', 'Blog')}</p>
        <h1 className="text-4xl sm:text-5xl font-bold text-white tracking-tight">{t('blog.title', 'Blogs')}</h1>
        <p className="text-white/40 mt-5 max-w-2xl mx-auto text-lg font-light">
          {t(
            'blog.subtitle',
            'Read the latest articles and insights from Cool & Care on security, HVAC, fire safety, and technology.'
          )}
        </p>
      </div>
    </section>
  );
};

export default BlogHeader;
